<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" rx="4" fill="#4149F7"/>
<rect opacity="0.4" x="4.79999" y="20.8" width="6.4" height="6.4" rx="1.5" fill="white"/>
<rect opacity="0.4" x="12.8" y="20.8" width="6.4" height="6.4" rx="1.5" fill="white"/>
<rect opacity="0.4" x="20.8" y="20.8" width="6.4" height="6.4" rx="1.5" fill="white"/>
<rect opacity="0.7" x="12.8" y="12.8" width="6.4" height="6.4" rx="1.5" fill="white"/>
<rect opacity="0.7" x="20.8" y="12.8" width="6.4" height="6.4" rx="1.5" fill="white"/>
<rect x="20.8" y="4.79999" width="6.4" height="6.4" rx="1.5" fill="white"/>
</svg>
